import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { LandingPage } from './pages/LandingPage';
import { LandingPageEN } from './pages/LandingPageEN';
import { SplashScreen } from './components/SplashScreen';
export function App() {
  const [showSplash, setShowSplash] = useState(true);
  const [language, setLanguage] = useState<'es' | 'en' | null>(null);
  const handleSplashComplete = (selectedLanguage: 'es' | 'en') => {
    setLanguage(selectedLanguage);
    setShowSplash(false);
  };
  return <>
      <AnimatePresence mode="wait" data-id="element-0">
        {showSplash && <SplashScreen onComplete={handleSplashComplete} data-id="element-1" />}
      </AnimatePresence>

      {!showSplash && (language === 'en' ? <LandingPageEN data-id="element-2" /> : <LandingPage data-id="element-3" />)}
    </>;
}